import { IonAlert, IonButton, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonRow, IonSpinner } from '@ionic/react';
import { alertCircleOutline, checkmarkCircle, warning } from 'ionicons/icons';
import moment from 'moment';
import QRCodeCanvas from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import AddToWallet from '../../components/addToWallet';
import { NormalText, SmallText, Spacer, StrongText, Subtitle } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import {
  checkBackgroundColor,
  forwardTo,
  getDefaultRoute,
  isDefined,
  isEmptyObject,
  isWebConfig,
} from '../../lib/utils';
import {
  getSubscriptions,
  reactivateSubscription,
  unsubscribe,
} from '../../store/subscription/actions';
import './index.css';
import Mobiscroll from '../../components/mobiscroll';
import FieldWrapper from '../../components/fieldWrapper';
import { ADD_SUBSCRIPTION_RESTAURANT } from '../../store/constants';

const { SelectOption } = Mobiscroll;

const MyMembership = ({
  __,
  subscriptions,
  active_subscription,
  selectedSubscription,
  getSubscriptions,
  unsubscribe,
  reactivateSubscription,
  navConfig,
  clientProfile,
  clientStyles,
  profile,
  location,
  restaurants,
  dispatch
}) => {
  useEffect(() => {
    getSubscriptions();
  }, []);
  if (isEmptyObject(active_subscription) && !location?.state?.stayOnPage) {
    forwardTo('/membership');
  }
  const [selectedStore, setSelectedStore] = useState(null)

  const [showSwitchMembershipAlert, setShowSwitchMembershipAlert] = useState(false);
  const [showCancelMembershipAlert, setShowCancelMembershipAlert] = useState(false);
  const [showReactivatingMembershipAlert, setShowReactivatingMembershipAlert] = useState(false);

  const handleClick = (active_subscription) => () => {
    if (active_subscription.cancellation_pending) {
      setShowReactivatingMembershipAlert(true);
    } else {
      setShowCancelMembershipAlert(true);
    }
  };

  const cancelMembershipAction = () => {
    setShowCancelMembershipAlert(false);
    unsubscribe();
  };

  const reactivateMembershipAction = () => {
    setShowReactivatingMembershipAlert(false);
    reactivateSubscription();
  };

  const setHomeStore = () => {
    dispatch({
      type: ADD_SUBSCRIPTION_RESTAURANT, data: {
        subscription_id: active_subscription.subscription_id,
        home_location_id: selectedStore
      }
    })
  }
  const backHandler = () => {
    const defaultRoute = getDefaultRoute(navConfig);
    forwardTo(defaultRoute.path);
  };
  const { hasAddToAppleWallet, hasAddToGoogleWallet } = getConfig().flags;
  // During the pending window active_subscription is an empty object, so fall
  // back to the package the user selected (state.orders.selectedSubscription).
  const subscriptionData =
    subscriptions.find((e) => e.id == active_subscription.id) ||
    subscriptions.find((e) => e.id == selectedSubscription?.id) || {
      image: '',
      description: ''
    }
  // Header fields come from active_subscription once it exists, otherwise from
  // the selected package (fields are named differently on each source).
  const packageName = active_subscription.package || subscriptionData.name || ''
  const packageCost = active_subscription.package_cost ?? subscriptionData.monthly_cost_inc_vat ?? 0
  const isYearlySubscription =
    active_subscription?.additional_config?.yearly_subscription ??
    subscriptionData?.additional_config?.yearly_subscription
  let logoColor = 'dark';

  if (clientStyles?.colors?.['--okx-loyalty-card-background']) {
    logoColor = checkBackgroundColor(clientStyles?.colors?.['--okx-loyalty-card-background'])
  }
  const logo_image = clientProfile.logo_image || ''
  const logo_image_light = clientProfile.logo_image_light || clientProfile.logo_image || ''
  const homeStore = restaurants.find(el => el.id == active_subscription.home_location_id)

  return (
    <Loading >
      <Layout
        showHamburger
        backHandler={backHandler}
        hideSecondToolbar={true}
        color="transparent"
        title={__('Your subscription')}
        headerWithTitle
      >

        <div className="absolute-content scrollable-y box-with-shadow">
          {location?.state?.success &&
            <>
              <div className="box-content on-creating-success">
                <IonIcon icon={checkmarkCircle}></IonIcon>
                <div>
                  <StrongText className="block">{__('Subscription successful')}</StrongText>
                  <Spacer size={0} />
                  <SmallText>{`${__('Your subscription will renew on ')} ${moment(active_subscription.next_renewal_date).format('MM/DD')}`}</SmallText>
                </div>
              </div>
              <Spacer size={1} />
            </>
          }
          {location?.state?.pending && isEmptyObject(active_subscription) &&
            <>
              <div className="box-content on-creating-warning">
                <IonSpinner color={'primary'} />
                <div>
                  <StrongText className="block">{__('Subscription is processing')}</StrongText>
                  <Spacer size={0} />
                  <SmallText>{`${__('Your subscription is currently being processed.')}`}</SmallText>
                </div>
              </div>
              <Spacer size={1} />
            </>
          }
          <div className='loyalty-header-with-image-wrapper box-content' style={{ '--okx-loyalty-background': 'var(--okx-loyalty-card-background)', '--okx-loyalty-text-color': 'var(--okx-loyalty-card-color)' }}>
            <IonGrid className='loyalty-header'>
              <IonRow>
                <IonCol>
                  <img src={logoColor == 'white' ? logo_image_light : logo_image} />
                </IonCol>

              </IonRow>
              <IonRow class='loyalty-card-image'>
                <img src={subscriptionData.image} />

              </IonRow>
              <IonRow>
                <IonCol>
                  <Subtitle className="bold">{packageName}</Subtitle>
                </IonCol>
              </IonRow>
              <IonRow className='centered qr-code-wrapper'>
                <QRCodeCanvas value={profile.qr_code} size={isWebConfig() ? 126 : 110} />
              </IonRow>
              <IonRow>
                <IonCol>
                  <Subtitle>
                    {Basket.formatPrice(packageCost / 100, true)}
                  </Subtitle>

                  <SmallText>{isYearlySubscription ? __('per year') : __('per month')}</SmallText>
                </IonCol>
                <IonCol class='righted'>
                  <Subtitle>{moment(active_subscription.next_renewal_date).format(isYearlySubscription ? 'LL' : 'LLL')}</Subtitle>
                  <SmallText>{active_subscription.cancellation_pending ? __('Ends on') : __('Renews on')}</SmallText>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
          <Spacer size={5} />

          {!isEmptyObject(active_subscription) &&
            <>
              {isDefined(profile.qr_code) &&
                profile.qr_code !== '' &&
                (hasAddToAppleWallet || hasAddToGoogleWallet) ? (
                <AddToWallet />
              ) : null}
              {!isWebConfig() &&
                <Spacer size={5} />

              }
              {(getConfig().flags.hasMembershipStore && !active_subscription.home_location_id) ?
                <>

                  <div className='box-content'>
                    <div className='centered'>
                      <IonIcon style={{ height: '48px', width: '48px' }} color='primary' icon={alertCircleOutline}></IonIcon>

                      <StrongText>{__('Choose home store')}</StrongText>
                      <Spacer size={2} />
                      <NormalText>{__('To obtain your benefits, please select your home store here:')}</NormalText>
                      <Spacer size={2} />

                    </div>
                    <FieldWrapper dropdown>
                      <SelectOption
                        theme='ios'
                        cssClass={isWebConfig() ? 'web' : ''}
                        display="center"
                        onSet={(event, data) => setSelectedStore(data.getVal())}
                        data={[{ value: '', text: '' }, ...restaurants.filter(el => el.is_published).map(el => ({ value: el.id, text: el.name }))]}
                        label="Location"
                        value={selectedStore}
                        inputStyle="box"
                        placeholder={__('Select store')}
                        cancelText={__('Cancel')}
                        setText={__('OK')}
                      />
                    </FieldWrapper>
                    <Spacer size={2} />
                    <IonButton onClick={setHomeStore} expand='block'>{__('Save & lock choice')}</IonButton>
                    <Spacer size={2} />

                    <NormalText>{__('This choice can only be made once. If you need to update it later, please contact us.')}</NormalText>

                  </div>

                </>

                :
                <div className='box-content'>


                  <div className='centered' style={{ display: 'grid', gap: 'var(--spacer-2)', gridAutoFlow: 'column', gridTemplateColumns: '25px 1fr' }}>
                    {active_subscription?.stripe_paused ? <>
                      <IonIcon style={{ height: '25px', width: '25px' }} icon={warning} />
                      <StrongText>{__('Subscription paused - payment overdue')}</StrongText>
                    </> : <>
                      <IonIcon style={{ height: '25px', width: '25px' }} color='success' icon={checkmarkCircle} />
                      <StrongText>{__('Subscription active')}</StrongText>
                    </>}

                  </div>
                  <Spacer size={2} />
                  <NormalText>{subscriptionData.description}</NormalText>
                  {subscriptionData.perks?.length > 0 &&
                    <>
                      <Spacer size={2} />

                      <div className="subscription-perks">
                        {subscriptionData.perks && subscriptionData.perks.map((el, index) => {
                          return (
                            <div key={`subscription-data_${index}`}>
                              <IonIcon icon={checkmarkCircle} color="primary" />
                              <NormalText>{__(el.name)}</NormalText>
                            </div>
                          );
                        })}
                      </div>            </>

                  }
                  {getConfig().flags.hasMembershipStore && <>
                    <Spacer size={3} />
                    <div className="input-field-container" style={{ pointerEvents: 'none' }}>
                      <StrongText>{__('Home store')}</StrongText>
                      <IonItem lines="none" className="input-field-wrapper ">
                        <IonInput
                          type="text"
                          pattern="text"
                          inputmode="text"
                          value={homeStore?.name}
                        ></IonInput>
                      </IonItem>
                    </div>
                  </>}
                </div>

              }


              <Spacer size={5} />
              <IonButton
                color={active_subscription.cancellation_pending ? 'secondary' : 'danger'}
                disabled={active_subscription === null}
                onClick={handleClick(active_subscription)}
                expand="block"
                fill={active_subscription.cancellation_pending ? 'solid' : 'clear'}
                className={'link'}
              >
                {active_subscription.cancellation_pending
                  ? __('Cancellation Pending - Reactivate?')
                  : __('Cancel subscription')}
              </IonButton>
            </>
          }
        </div>

        <IonAlert
          isOpen={showSwitchMembershipAlert}
          header={__('Confirm Change')}
          message={__(
            'Are you sure you wish to change your membership? Your new package will start at the next scheduled renewal date.',
          )}
          buttons={[
            { text: __('Cancel'), handler: () => setShowSwitchMembershipAlert(false) },
            { text: __('OK'), handler: () => setShowSwitchMembershipAlert(false) },
          ]}
        />
        <IonAlert
          isOpen={showCancelMembershipAlert}
          header={__('Are you sure')}
          message={__('By cancelling your membership it will not renew on the scheduled date.')}
          buttons={[
            {
              text: __('Done'),
              handler: cancelMembershipAction,
              cssClass: 'primary'
            },
            {
              text: __('Cancel'),
              cssClass: 'link secondary',

              handler: () => setShowCancelMembershipAlert(false)
            },

          ]}
        />
        <IonAlert
          isOpen={showReactivatingMembershipAlert}
          header={__('Are you sure')}
          message={__(
            'By reactivating your membership it will renew on the scheduled renewal date.',
          )}
          buttons={[

            {
              text: __('Done'),
              handler: reactivateMembershipAction,
              cssClass: 'primary'

            },
            {
              text: __('Cancel'),
              cssClass: 'link secondary',
              handler: () => setShowReactivatingMembershipAlert(false),
            },
          ]}
        />
      </Layout>
    </Loading>
  );
};

const mapStateToProps = (store) => ({
  subscriptions: store.subscription.subscriptions,
  active_subscription: store.profile.profile.active_subscription,
  selectedSubscription: store.orders.selectedSubscription,
  navConfig: store.common.navConfig,
  clientProfile: store.common.clientProfile,
  clientStyles: store.common.clientStyles,
  profile: store.profile.profile,
  restaurants: store.restaurants.restaurants
});

const mapDispatchToProps = {
  getSubscriptions,
  unsubscribe,
  reactivateSubscription,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(MyMembership));
